(function () {
  var MARK = '更優惠';
  var CLASS = 'more-value-accent';

  function wrapTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    var text = node.nodeValue;
    if (!text || text.indexOf(MARK) === -1) return;
    if (node.parentElement && node.parentElement.classList.contains(CLASS)) return;

    var parts = text.split(MARK);
    var frag = document.createDocumentFragment();
    parts.forEach(function (part, i) {
      if (part) frag.appendChild(document.createTextNode(part));
      if (i < parts.length - 1) {
        var span = document.createElement('span');
        span.className = CLASS;
        span.textContent = MARK;
        frag.appendChild(span);
      }
    });
    node.parentNode.replaceChild(frag, node);
  }

  function walk(el) {
    if (!el) return;
    var texts = el.querySelectorAll('.variant-option__button-label__text, .variant-option__swatch-value');
    texts.forEach(function (label) {
      if (label.querySelector('.' + CLASS)) return;
      Array.prototype.slice.call(label.childNodes).forEach(wrapTextNode);
    });
  }

  function run() {
    walk(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('variant:change', run);

  var root = document.getElementById('MainContent') || document.body;
  if (root && window.MutationObserver) {
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    });
    obs.observe(root, { childList: true, subtree: true });
  }
})();
